import { post } from "../../helpers/api";
import { showToast as toast } from "../../components/Modals/toast";
import { i18n } from "../../main"; // Adjust the import path accordingly

const state = {
    items: [],
    isLoadingData: true,
    isBtnLoading: false,
    isBtnEditLoading: false,
    search: "",
    isShowResultDialog: false,
    resultMsg: "",
    isSuccess: false,
    itemsPOS: [],
    searchPos: "",
    ca_id: "",
    customerItemHistory: {},
};

const mutations = {
    SET_IS_BTN_LOADING(state, isBtnLoading) {
        state.isBtnLoading = isBtnLoading;
    },
    SET_IS_LOADING_DATA(state, isLoadingData) {
        state.isLoadingData = isLoadingData;
    },

    REMOVE_ITEM(state, id) {
        state.items = state.items.filter((item) => {
            return item.i_id !== id;
        });
    },

    SET_SEARCH_POS(state, search) {
        state.searchPos = search;
    },
    SET_DELETE_SUCCESS(state, value) {
        state.isShowResultDialog = value.state;
        state.resultMsg = value.msg;
        state.isSuccess = value.isSuccess;
    },

    SET_ITEMS_POS(state, itemsPOS) {
        state.itemsPOS = itemsPOS;
    },
    SET_CUSTOMER_ITEM_HISTORY(state, data) {
        if (!state.customerItemHistory) {
            state.customerItemHistory = {};
        }
        state.customerItemHistory[data.itemId] = data.history;
    },
};

const actions = {
    async getItemsPOS({ commit }, payload) {
        try {
            post("item/get-items-pos", payload)
                .then((response) => {
                    commit("SET_ITEMS_POS", response.data);
                    commit("SET_IS_BTN_LOADING", false);
                    commit("SET_IS_BTN_EDIT_LOADING", false);
                    commit("SET_IS_LOADING_DATA", false);
                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (error) {
            console.log(error);
        }
    },

    async addNewItem({ commit }, payload) {
        return post("invoice/store", payload, {
                id: 19,
                action: "add",
            })
            .then((response) => {
                const t = i18n.global.t;
                toast("success", t("added_successfully"));
                return response;
            })
            .catch((error) => {
                commit("SET_IS_BTN_LOADING", false);
                const t = i18n.global.t;
                if (error.response.status == 408) {
                    //you don't have permission to add new item message in toast
                    toast("error", t("you_dont_have_permission_to_do_this_action"));
                    return error;
                }
                if (
                    error.response.data.message.includes(
                        "Item quantity is less than sold item quantity"
                    )
                ) {
                    commit("SET_DELETE_SUCCESS", {
                        state: true,
                        msg: t("item_quantity_is_less_than_sold_item_quantity"),
                        isSuccess: false,
                    });
                } else if (error.response.status == 400) {
                    //you don't have permission to add new item message in toast
                    toast("error", error.response.data.message);
                    return error;
                } else {
                    toast("error", t("something_wrong"));
                }
                console.log(error);
                return error;
            });
    },

    // eslint-disable-next-line no-unused-vars
    async getCustomerItemHistory({ commit }, payload) {
        try {
            const response = await post(
                "invoice/get-customer-item-history",
                payload, {
                    id: 19,
                    action: "view",
                }
            );
            console.log("Customer item history response:", response.data);

            // Commit the data to store
            commit("SET_CUSTOMER_ITEM_HISTORY", {
                itemId: payload.i_id,
                history: response.data.data,
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching customer item history:", error);
            throw error;
        }
    },
};

const getters = {
    filterItemsPOS(state) {
        function deepSearch(obj, searchValue) {
            if (state.ca_id !== "") {
                if (obj.ca_id !== state.ca_id) {
                    return false;
                }
            }
            for (const key in obj) {
                const value = obj[key];

                if (value !== null && typeof value === "object") {
                    // If the value is an object, recursively search inside it
                    if (deepSearch(value, searchValue)) {
                        return true; // Found a match in a nested object
                    }
                } else {
                    // If the value is not an object, check if it includes the search value
                    if (
                        value != null &&
                        value.toString().toLowerCase().includes(searchValue.toLowerCase())
                    ) {
                        return true; // Found a match
                    }
                }
            }
            return false; // No match found in this object
        }

        return state.itemsPOS.filter((item) => {
            // Search in all fields recursively
            return deepSearch(item, state.searchPos.toLowerCase());
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};